(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1535],{

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js

function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js


const _excluded = ["className", "raised"];











const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};

const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });

  const {
    className,
    raised = false
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 44267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardContent_CardContent; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/cardContentClasses.js

function getCardContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardContent', slot);
}
const cardContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardContent', ['root']);
/* harmony default export */ var CardContent_cardContentClasses = ((/* unused pure expression or super */ null && (cardContentClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/CardContent.js


const _excluded = ["className", "component"];









const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardContentUtilityClass, classes);
};

const CardContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react.forwardRef(function CardContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardContent'
  });

  const {
    className,
    component = 'div'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardContentRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardContent_CardContent = (CardContent);

/***/ }),

/***/ 27941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ AppDownload; },
/* harmony export */   "Z": function() { return /* binding */ AppSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50122);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65907);
/* eslint-disable no-unreachable */ /* eslint-disable react/prop-types */ 



function AppSection() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        direction: "row",
        my: 1,
        p: 1,
        spacing: 2,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/tai-app/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        src: "/icons/qr.jpg",
                        sx: {
                            cursor: "pointer"
                        },
                        alt: "tải app"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/tai-app/",
                        target: "_blank",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                src: "/icons/ic_ios.jpg",
                                alt: "ios"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/tai-app/",
                        target: "_blank",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                src: "/icons/ic_android.jpg",
                                alt: "android"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
function AppDownload() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                sx: {
                    mb: 3
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                variant: "subtitle1",
                children: "Tải App di động v\xe0 chia sẻ"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                direction: "row",
                my: 2,
                spacing: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/tai-app/",
                        target: "_blank",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            src: "/icons/qr.jpg",
                            alt: "",
                            sx: {
                                width: 50,
                                height: 60,
                                cursor: "pointer"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/tai-app/",
                        target: "_blank",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            src: "/icons/ic_ios.jpg",
                            alt: "",
                            sx: {
                                width: 120,
                                height: 50,
                                cursor: "pointer"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/tai-app/",
                        target: "_blank",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            src: "/icons/ic_android.jpg",
                            alt: "",
                            sx: {
                                width: 130,
                                height: 50,
                                cursor: "pointer"
                            }
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 27286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardAds; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44267);
/* harmony import */ var _GoogleAds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28075);
// @mui


// components

function CardAds() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GoogleAds__WEBPACK_IMPORTED_MODULE_1__/* .GoogleBannerAds */ .D, {})
        })
    });
}


/***/ }),

/***/ 28075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ GoogleBannerAds; },
/* harmony export */   "a": function() { return /* binding */ GoogleGridAds; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function GoogleBannerAds() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
        className: "adsbygoogle",
        style: {
            display: "block"
        },
        "data-ad-client": "ca-pub-2522844423315072",
        "data-ad-slot": "1281160371",
        "data-ad-format": "auto",
        "data-full-width-responsive": "true"
    });
}
function GoogleGridAds() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
        className: "adsbygoogle",
        style: {
            display: "block"
        },
        "data-ad-format": "autorelaxed",
        "data-ad-client": "ca-pub-2522844423315072",
        "data-ad-slot": "6470023398"
    });
}


/***/ }),

/***/ 16634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommentList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(153);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10633);
/* harmony import */ var _components_EmptyContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77251);
/* harmony import */ var _components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37549);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9671);
/* harmony import */ var _redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29050);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33599);
/* harmony import */ var _CommentItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83741);
/* eslint-disable react-hooks/exhaustive-deps */ 



// @mui







// ----------------------------------------------------------------------
function CommentList() {
    var dispatch = (0,_redux_store__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().translate;
    var ref = (0,_redux_store__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.blogComment;
    }), comments = ref.comments, totalPages = ref.totalPages, isLoading = ref.isLoading, search = ref.search, numberOfElements = ref.numberOfElements;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"), sortBy = ref1[0], setSortBy = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timeout = setTimeout(function() {
            dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .getComments */ .li)());
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        search
    ]);
    var handleChangePage = function(_, value) {
        dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: value - 1
        })));
    };
    var handleChangeSort = function(event) {
        var value = event.target.value;
        var orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        if (value === "0") orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        else if (value === "1") orders = [
            {
                order: "asc",
                property: "createdAt"
            }
        ];
        else orders = [
            {
                order: "desc",
                property: "likeNo"
            }
        ];
        dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: 0,
            orders: orders
        })));
        setSortBy(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        my: 1,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        variant: "caption",
                        children: [
                            translate("label.sortBy"),
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        variant: "standard",
                        value: sortBy,
                        size: "small",
                        sx: {
                            fontSize: 12,
                            fontWeight: "bold",
                            ml: 1,
                            pt: 1
                        },
                        disableUnderline: true,
                        onChange: handleChangeSort,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "0",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByNew")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "1",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByOld")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "2",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByLike")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                spacing: 2,
                children: [
                    comments.map(function(comment) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommentItem__WEBPACK_IMPORTED_MODULE_7__/* .CommentItemWrapper */ .w, {
                            comment: comment
                        }, comment.id);
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_3__/* .SkeletonCommentItem */ .bG, {}) : numberOfElements == 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_EmptyContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        title: " ",
                        description: translate("label.noComment")
                    })
                ]
            }),
            numberOfElements > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                alignItems: "center",
                my: 1.5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    count: totalPages,
                    variant: "text",
                    page: search.page + 1,
                    onChange: handleChangePage
                })
            })
        ]
    });
}


/***/ }),

/***/ 29790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ StreetExamSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./src/components/AppSection.js
var AppSection = __webpack_require__(27941);
// EXTERNAL MODULE: ./src/components/CardAds.js
var CardAds = __webpack_require__(27286);
// EXTERNAL MODULE: ./src/components/GoogleAds.js
var GoogleAds = __webpack_require__(28075);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/hooks/useResponsive.js
var useResponsive = __webpack_require__(55102);
// EXTERNAL MODULE: ./src/hooks/useSettings.js
var useSettings = __webpack_require__(40571);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(87952);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Scrollbar.js + 26 modules
var Scrollbar = __webpack_require__(91045);
;// CONCATENATED MODULE: ./src/sections/streetExam/MenuSection.js
/* eslint-disable react/prop-types */ 






// ----------------------------------------------------------------------
function MenuSection(param) {
    var streetExams = param.streetExams;
    var theme = (0,useTheme/* default */.Z)();
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Scrollbar/* default */.Z, {
            sx: {
                maxHeight: themeStretch ? 590 : 450
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        p: 1,
                        bgcolor: theme.palette.primary.dark,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "#fff",
                            children: "B\xe0i thi đường trường \xf4 t\xf4"
                        })
                    }),
                    streetExams === null || streetExams === void 0 ? void 0 : streetExams.map(function(s) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SituationItem, {
                            item: s
                        }, s.id);
                    })
                ]
            })
        })
    });
}
function SituationItem(param) {
    var item = param.item;
    var theme = (0,useTheme/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var pathname = router.asPath.replace("/thi-duong-truong/", "").replace("/", "");
    var slug = item.slug, title = item.title, orderNo = item.orderNo;
    var isActive = pathname === slug || pathname === "" && orderNo === 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/thi-duong-truong/".concat(slug),
        passHref: true,
        scroll: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            spacing: 2,
            alignItems: "center",
            bgcolor: theme.palette.background.neutral,
            my: 0.5,
            py: 1.2,
            sx: {
                cursor: "pointer",
                borderRadius: 0.5
            },
            children: [
                !isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    sx: {
                        bgcolor: theme.palette.text.secondary,
                        color: theme.palette.background.default
                    },
                    variant: "rounded",
                    children: orderNo
                }),
                isActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        position: "relative",
                        display: "inline-flex",
                        borderRadius: 1,
                        backgroundColor: theme.palette.text.secondary
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: "absolute",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                color: theme.palette.background.default,
                                children: orderNo
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "subtitle2",
                    color: theme.palette.text.primary,
                    fontWeight: 500,
                    children: title
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./src/components/FBSocial.js
var FBSocial = __webpack_require__(36239);
// EXTERNAL MODULE: ./src/components/Iconify.js
var Iconify = __webpack_require__(22554);
// EXTERNAL MODULE: ./src/components/Markdown.js
var Markdown = __webpack_require__(81320);
// EXTERNAL MODULE: ./src/sections/comment/CommentList.js
var CommentList = __webpack_require__(16634);
// EXTERNAL MODULE: ./src/sections/comment/CommentNewForm.js
var CommentNewForm = __webpack_require__(79136);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/video.js/dist/video.es.js
var video_es = __webpack_require__(85215);
// EXTERNAL MODULE: ./node_modules/videojs-contrib-quality-levels/dist/videojs-contrib-quality-levels.js
var videojs_contrib_quality_levels = __webpack_require__(78984);
// EXTERNAL MODULE: ./node_modules/videojs-http-source-selector/dist/videojs-http-source-selector.es.js
var videojs_http_source_selector_es = __webpack_require__(85258);
// EXTERNAL MODULE: ./node_modules/videojs-youtube/dist/Youtube.js
var Youtube = __webpack_require__(72575);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(33726);
;// CONCATENATED MODULE: ./src/sections/streetExam/VideoPlayerPreview.js
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ 






// ----------------------------------------------------------------------
function VideoPlayerPreview(param) {
    var video = param.video;
    var playerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!playerRef.current) {
            var options = {
                playbackRates: [
                    0.5,
                    1,
                    1.5,
                    2
                ],
                fluid: true,
                fill: true,
                responsive: true,
                controls: true,
                preload: "auto",
                autoplay: true,
                aspectRatio: "16:9",
                controlBar: {
                    remainingTimeDisplay: false,
                    currentTimeDisplay: true,
                    pictureInPictureToggle: false,
                    playbackRateMenuButton: false,
                    timeDivider: true,
                    durationDisplay: true
                },
                inactivityTimeout: 5,
                plugins: {
                    httpSourceSelector: {
                        default: "auto"
                    }
                },
                html5: {
                    vhs: {
                        overrideNative: true
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false
                }
            };
            playerRef.current = (0,video_es["default"])("video_1", options);
            video_es["default"].log.level("off");
        }
    }, []);
    (0,react.useEffect)(function() {
        var player = playerRef.current;
        return function() {
            if (player && !player.isDisposed()) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, [
        playerRef
    ]);
    (0,react.useEffect)(function() {
        var player = playerRef.current;
        if (video) {
            var id = video.id;
            player.poster("".concat(config/* BASEURL */.Hc, "/stream/video/").concat(id, "/thumbnail/thumb.jpg"));
            player.src({
                src: "".concat(config/* BASEURL */.Hc, "/stream/video/").concat(id, "/index.m3u8"),
                type: "application/x-mpegURL"
            });
        }
    }, [
        video
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        id: "video_1",
        className: "video-js vjs-theme-city",
        style: {
            marginBottom: 10
        }
    });
}

;// CONCATENATED MODULE: ./src/sections/streetExam/VideoSection.js
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ "use client";










function VideoSection(param) {
    var currentItem = param.currentItem, prevItem = param.prevItem, nextItem = param.nextItem;
    var translate = (0,useLocales/* default */.Z)().translate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayerPreview, {
                video: currentItem
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 2,
                px: (currentItem === null || currentItem === void 0 ? void 0 : currentItem.id) ? 0 : 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/thi-duong-truong/".concat(prevItem === null || prevItem === void 0 ? void 0 : prevItem.slug),
                                passHref: true,
                                scroll: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    disabled: !prevItem,
                                    variant: "outlined",
                                    size: "large",
                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                        icon: "material-symbols:arrow-back-ios"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                color: "primary",
                                children: currentItem === null || currentItem === void 0 ? void 0 : currentItem.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/thi-duong-truong/".concat(nextItem === null || nextItem === void 0 ? void 0 : nextItem.slug),
                                passHref: true,
                                scroll: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    disabled: !nextItem,
                                    variant: "outlined",
                                    size: "large",
                                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                        icon: "material-symbols:arrow-forward-ios"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ql-snow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ql-editor",
                            style: {
                                padding: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* default */.Z, {
                                children: currentItem === null || currentItem === void 0 ? void 0 : currentItem.description
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FBSocial/* SocialShare */.D, {
                        title: currentItem === null || currentItem === void 0 ? void 0 : currentItem.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            mb: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            children: translate("button.comment")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentNewForm/* default */.Z, {
                        itemId: currentItem === null || currentItem === void 0 ? void 0 : currentItem.orderNo,
                        type: "STREETEXAM"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList/* default */.Z, {})
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./src/components/Image.js
var Image = __webpack_require__(65907);
;// CONCATENATED MODULE: ./src/sections/streetExam/Welcome.js
// @mui




//

// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        boxShadow: "none",
        textAlign: "center",
        backgroundColor: theme.palette.error.lighter
    }, theme.breakpoints.up("md"), {
        height: "100%",
        display: "flex",
        textAlign: "left",
        alignItems: "center",
        justifyContent: "space-between"
    });
});
// ----------------------------------------------------------------------
function Welcome() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                sx: {
                    color: "grey.800",
                    p: {
                        md: 0
                    },
                    pl: {
                        md: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        gutterBottom: true,
                        variant: "h4",
                        children: [
                            "Thi Đường Trường,",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "\xd4 T\xd4 HẠNG",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "B, C, D, E, F"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            pb: {
                                xs: 3,
                                xl: 5
                            },
                            maxWidth: 480,
                            mx: "auto"
                        },
                        children: "B\xe0i thi đường trường \xf4 t\xf4 hạng B, C, D, E, F gi\xfap học vi\xean nắm vững kiến thức trước khi thi."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                alt: "",
                src: "/illustrations/road.png",
                sx: {
                    p: 3,
                    height: 260,
                    margin: {
                        xs: "auto",
                        md: "inherit"
                    },
                    width: 260
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/streetExam/StreetExamSection.js
/* eslint-disable react/prop-types */ 











var StreetExamSection_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(15),
        paddingBottom: theme.spacing(15)
    });
});
function StreetExamSection(param) {
    var nextItem = param.nextItem, prevItem = param.prevItem, currentItem = param.currentItem, streetExams = param.streetExams;
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "md");
    var translate = (0,useLocales/* default */.Z)().translate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: themeStretch ? "xl" : "lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreetExamSection_RootStyle, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    my: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 12,
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h2",
                            textAlign: "center",
                            textTransform: "capitalize",
                            children: translate("streetExam.title")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    my: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 2.5,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuSection, {
                                    streetExams: streetExams
                                }),
                                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    p: 1,
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSection/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAds/* GoogleBannerAds */.D, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAds/* GoogleBannerAds */.D, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 9.5,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSection, {
                                currentItem: currentItem,
                                prevItem: prevItem,
                                nextItem: nextItem
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAds/* GoogleGridAds */.a, {})
                        })
                    ]
                })
            ]
        })
    });
}
function Banner() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 3,
        mb: 5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Welcome, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardAds/* default */.Z, {})
            })
        ]
    });
}


/***/ }),

/***/ 25893:
/***/ (function() {

/* (ignored) */

/***/ })

}]);